export const COMPONENT_NAME = 'FormCollection';
